<template>
  <div class="page">
    <!--头部-->
    <div class="title"><i class="iconfont icon-userInfodazhe"></i>用户管理</div>

    <div class="page-content">
      <!--body-->
      <el-main >
        <!--用户信息筛选-->
        <el-row style="float: left">
          <el-form style="font: bold" :inline="true" label-width="100px" size="small" :model="formInline">
            <el-form-item label="用户名：">
              <el-input v-model="formInline.userName" clearable placeholder="用户名"></el-input>
            </el-form-item>
            <el-form-item label="用户状态：">
              <el-select v-model="formInline.status" clearable placeholder="请选择">
                <el-option label="请选择" value />
                <el-option v-for="types in userStatus" :key="types.id" :value="types.id" v-text="types.name" :label="types.name" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="queryUserInfo" style="backgroundcolor: #2a3861; bordercolor: transparent">查询 </el-button>
              <el-button type="primary" @click="addUserInfo" style="backgroundcolor: #2a3861; bordercolor: transparent">新增 </el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <!-- 用户信息表格区域  :loading="loading"-->
        <el-table
          height="65vh"
          :data="tableData"
          border
          :header-cell-style="{
            'text-align': 'center',
            background: '#F5F6FA',
            color: '#646E92',
          }"
          style="
            width: 96%;
            margin-top: 30px;
            margin-left: 25px;
            color: #666e92;
            font-size: 14px;
          "
          :cell-style="{ 'text-align': 'center' }"
        >
          <el-table-column prop="userName" label="用户名" width="100"></el-table-column>
          <el-table-column prop="password" label="密码" show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="scope.row.isShowPass == true">
                {{ passwordFormat(scope.row.password) }}
              <i slot="suffix" class="el-input__icon el-icon-view" @click="showPassword('show', scope.$index)"></i>
              </div>
              <div v-else>
                ******
                <i slot="suffix" class="el-input__icon el-icon-view" @click="showPassword('hide', scope.$index)"></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="用户状态" width="100">
            <template slot-scope="scope">
              {{ scope.row.status == '0' ? '正常' : '禁用' }}
            </template>
          </el-table-column>
          <el-table-column prop="companyName" label="公司名称" width="280" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="160" :formatter="formatTime"> </el-table-column>
          <el-table-column prop="updateTime" label="修改时间" width="160" :formatter="formatTime"> </el-table-column>
          <el-table-column align="center" label="操作" width="250">
            <template slot-scope="scope" align="center">
              <el-switch
                v-model="scope.row.status"
                :active-value="0"
                :inactive-value="1"
                :width="35"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="changeSwitch(scope.row, scope.$index)"
              >
              </el-switch>
              &nbsp;&nbsp;
              <el-link :underline="false" style="color: #7698fc" @click="editUserInfo(scope.row)"><i class="el-icon-edit-outline fs-icon" title="编辑"></i></el-link>
              &nbsp;
              <el-link :underline="false" type="danger" @click="deleteUserInfoId(scope.row)"><i class="el-icon-delete fs-icon" title="删除"></i></el-link>
              &nbsp;
              <el-link :underline="false" style="color: #7698fc" @click="showMenuDialog(scope.row)"><i class="el-icon-menu fs-icon" title="菜单授权"></i></el-link>
              &nbsp;
              <el-link :underline="false" style="color: #7698fc" @click="showShopDialog(scope.row)"><i class="el-icon-s-shop fs-icon" title="门店授权"></i></el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <!--尾部-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 15, 20, 25, 30]"
        layout="total, sizes,prev, pager, next, jumper"
        :total="total"
        background
      />
      <!-- 新增用户弹框 -->
      <el-dialog :title="modelTitle" width="30%" :visible.sync="addRoleDialog" class="showAll_dialog" :close-on-click-modal="false">
        <el-form class="form-dialog" label-width="150px" :model="addrole" ref="addrole" :rules="addUserRule">
          <el-form-item label="用户名：" prop="userName">
            <el-input v-model="addrole.userName" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item label="密码：" prop="password" v-if="this.isAdd">
            <el-input v-model="addrole.password" prefix-icon="el-icon-lock" placeholder="请输入密码" show-password></el-input>
          </el-form-item>
          <el-form-item label="确认密码：" prop="confirmPassword" v-if="this.isAdd">
            <el-input v-model="addrole.confirmPassword" prefix-icon="el-icon-lock" placeholder="请输入确认密码" show-password></el-input>
          </el-form-item>
          <el-form-item label="密码：" prop="password" v-if="this.isModify">
            <el-input v-model="addrole.password" prefix-icon="el-icon-lock" placeholder="请输入新密码" show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="cancelUserInfo()">取 消</el-button>
            <el-button @click="addRole('addrole')" style="background-color: #4c74e0; color: white">提 交</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 门店授权弹框 -->
      <el-dialog title="菜单授权" width="30%" :visible.sync="menuAuthDialog" class="dialog-large" :close-on-click-modal="false" center>
        <div class="menus-tree">
          <el-tree ref="menusTree" :data="treeMenusData" show-checkbox node-key="id" default-expand-all :props="defaultProps"></el-tree>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="menuAuthDialog = false">取 消</el-button>
          <el-button type="primary" @click="addMenusDialog">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 门店授权弹框 -->
      <el-dialog title="门店授权" width="40%" :visible.sync="shopAuthDialog" class="dialog-large" :close-on-click-modal="false">
        <el-table
          v-if="shopAuthDialog"
          :data="dataShops"
          ref="shopTableRef"
          border
          :header-cell-style="{
            'text-align': 'center',
            background: '#F5F6FA',
            color: '#646E92',
          }"
          style="color: #666e92;"
          :cell-style="{ 'text-align': 'center' }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="50" :selectable="selectable"> </el-table-column>
          <el-table-column label="序号">
            <template slot-scope="scope"> {{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="shopName" label="店铺名称" show-overflow-tooltip> </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="shopAuthDialog = false">取 消</el-button>
          <el-button type="primary" @click="addUserShopDialog">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ElRow from 'element-ui/packages/row/src/row';
import ElMain from 'element-ui/packages/main/src/main';
import ElFooter from 'element-ui/packages/footer/src/main';
import moment from 'moment';
import { Base64 } from 'js-base64';
import row from 'element-ui/packages/row/src/row';
export default {
  components: {
    ElFooter,
    ElMain,
    ElRow,
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  data() {
    var user = JSON.parse(window.sessionStorage['user']);
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.addrole.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      importSkuInfoShow: false,
      file: {},
      filterText: '' /*树形筛选绑定*/,
      props: {
        /*配置树形权限菜单显示*/
        label: 'name',
        children: 'children',
      },
      userStatus: [
        {
          name: '正常',
          id: 0,
        },
        {
          name: '禁用',
          id: 1,
        },
      ],
      /*创建角色*/
      addRoleDialog: false,
      addrole: {
        id: undefined,
        userName: '',
        password: '',
        confirmPassword: '',
      },
      modelTitle: '',
      /*编辑角色*/
      editRoleDialog: false,
      editrole: {
        id: undefined,
        name: '',
        description: '',
        authorityIds: [],
      },
      addUserRule: {
        userName: [{ required: true, message: '用户名必填', trigger: 'blur' }],
        password: [
          { required: true, message: '密码必填', trigger: 'blur' },
          { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true, message: '确认密码必填', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' },
        ],
      },
      data: [{}] /*绑定新增角色树的数据*/,
      formInline: {
        userName: '',
        status: '',
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      btn: false,
      fileList: [],
      file: {},
      row: '',
      col: '',
      tmpRow: {},
      uploadDialog: false,
      dialogVisible: false,
      dataSites: [],
      dataShops: [],
      flagClick: false,
      isAdd: false,
      isModify: false,
      user: user,
      roleCode: user.roleCode,
      dialogUserInfoId: 0,
      menuAuthDialog: false,
      treeMenusData: [],
      treeMenuCheckKeys: [],
      treeCurNodeKeys: '',
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      shopAuthDialog: false,
      multipleSelection: [],
    };
  },
  created() {
    this.query(); /*绑定树*/
    this.getAllDicts();
    this.getShops();
  },
  methods: {
    showPassword(op, _index) {
      if (op == 'hide') {
        this.$set(this.tableData[_index], "isShowPass", true);
      } else {
        this.$set(this.tableData[_index], "isShowPass", false);
      }
    },
    // 密码转换
    passwordFormat(password) {
      
      return Base64.decode(password);
    },
    getShops() {
      /*获取所有店铺*/
      let shopUrl = "/api/shop/list?flag=1";
      this.axios.get(shopUrl).then((r) => {
        if (r.data.code == 200) {
          let data = r.data.data;
          this.dataShops = data;
        }
      });
    },
    getAllDicts() {
      /*获取所有字典*/
      this.axios.get('/api/dict/map').then((r) => {
        let data = r.data.data;
        for (var key in data) {
          if (key.indexOf('1130') == 0) {
            let siteData = data[key];
            siteData.map((item) => {
              item.codeName = item.codeValue + '（' + item.codeName + '）';
            });
            this.dataSites = siteData;
          }
        }
      });
    },
    realChange(val) {
      var obj = {};
      obj = this.dataShops.find(function(i) {
        return i.id === val;
      });
      this.formInline.shopName = obj.shopName;
    },
    formatTime(row, column) {
      let date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
    handleSizeChange(val) {
      /*改变显示条数*/
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange() {
      this.query();
    },
    putdata(resp) {
      this.$data.tableData = resp.data.data && resp.data.data.records ? resp.data.data.records : [];
      this.$data.total = resp.data.data.total;
      this.$data.user = JSON.parse(sessionStorage.getItem('user'));
      this.$data.roleCode = this.$data.user.roleCode;
    },
    queryUserInfo() {
      this.$data.currentPage = 1;
      this.query();
    },
    query() {
      //条件筛选
      let o = {
        ...this.formInline,
      };
      this.axios
        .get('/api/user-info/queryUserInfoList', {
          params: { ...o, current: this.$data.currentPage, size: this.$data.pageSize },
        })
        .then(this.putdata, (err) => {
          console.log('err', err);
        });
    },
    addUserInfo() {
      this.isAdd = true;
      this.isModify = false;
      this.addRoleDialog = true;
      this.modelTitle = '新增用户信息';
      this.flagClick = true;
    },
    cancelUserInfo() {
      this.addrole = {
        id: undefined,
        userName: '',
        password: '',
        confirmPassword: '',
      };
      // }
      this.addRoleDialog = false;
    },
    editUserInfo(row) {
      /*绑定修改信息*/
      this.addRoleDialog = true;
      this.modelTitle = '修改用户信息';
      this.addrole = JSON.parse(JSON.stringify(row));
      this.addrole.password = this.passwordFormat(this.addrole.password);
      this.isModify = true;
      this.isAdd = false;
    },
    addRole(addrole) {
      /*新增修改*/
      this.$refs[addrole].validate((valid) => {
        if (valid) {
          let role = {
            userName: this.addrole.userName,
            password: Base64.encode(this.addrole.password),
            confirmPassword: Base64.encode(this.addrole.confirmPassword),
            userInfoId: this.addrole.userInfoId
          };
          if (role.userInfoId) {
            this.axios.put('/api/user-info/modify', role).then(
              (resp) => {
                if (resp.data.code == 200) {
                  this.$message('修改成功');
                  this.query(); /*查询渲染界面*/
                } else {
                  this.$message.info(resp.data.msg);
                }
              },
              (err) => {
                console.log('err', err);
              }
            );
          } else {
            this.axios.post('/api/user-info/add', role).then(
              (resp) => {
                if (resp.data.code == 200) {
                  this.$message('添加成功');
                  this.query(); /*查询渲染界面*/
                } else {
                  this.$message.info(resp.data.msg);
                }
              },
              (err) => {
                console.log('err', err);
              }
            );
          }
          this.cancelUserInfo(); /*关闭弹窗*/
        } else {
          console.log('验证没通过');
          return false;
        }
      });
    },
    downloadCallback(res, fileName) {
      var blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8' });
      var download = document.createElement('a');
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      download.style.display = 'none';
      download.href = href;
      download.download = fileName; //下载后文件名
      document.body.appendChild(download);
      download.click(); //点击下载
      document.body.removeChild(download); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    getFileName(res) {
      let fileName = decodeURI(res.headers['content-disposition'].split('=')[1]);
      return fileName;
    },
    deleteUserInfoId(row) {
      /*删除角色*/
      this.$msgbox
        .confirm('此操作将删除用户, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          this.axios.delete('/api/user-info/removeById?userInfoId=' + row.userInfoId).then(
            (resp) => {
              if (resp.data.code == 200) {
                this.$message('删除成功');
                this.query();
              } else {
                this.$message(resp.data.msg);
              }
            },
            (err) => {
              console.log('err', err);
            }
          );
        })
        .catch(() => {
          this.$message.error('已取消');
        });
    },
    setMD5(md5) {
      let formData = new FormData();
      // 向 formData 对象中添加文件
      // formData.append("md5", this.upload.md5);
      formData.append('file', this.file.raw);
      let config = {
        //添加请求头
        headers: { 'Content-Type': 'multipart/form-data' },
        //添加上传进度监听事件
        onUploadProgress: (e) => {
          var completeProgress = (((e.loaded / e.total) * 100) | 0) + '%';
          this.progress = completeProgress;
        },
      };
    },
    // 用户禁用/启用
    changeSwitch(row, _index) {
      this.axios
        .get('/api/user-info/status', {
          params: { userInfoId: row.userInfoId },
        })
        .then((res) => {
          let value = res.data.data;
          this.$set(this.tableData[_index], "status", value);
          this.$message(value == 1 ? '禁用成功！' : '启用成功！');
        });
    },
    // 显示菜单授权弹窗
    showMenuDialog(row) {
      this.treeMenusData = [];
      this.treeMenuCheckKeys = [];
      this.treeCurNodeKeys = '';
      this.dialogUserInfoId = row.userInfoId;
      // 获取全部菜单
      this.axios.get('/api/user-info/getAllMenu').then((res) => {
        const data = res.data.data;
        let arrTree = [];
        for (let item1 of data) {
          if (item1) {
            let obj = {
              id: item1.id,
              label: item1.menuName,
              children: [],
            };
            if (item1.childList && item1.childList.length > 0) {
              for (let item2 of item1.childList) {
                obj.children.push({
                  id: item2.id,
                  label: item2.menuName,
                });
              }
            }
            arrTree.push(obj);
          }
        }
        this.treeMenusData = arrTree;
        setTimeout(() => {
          this.getCurrentUserMenus(row);
        });
      });
    },
    // 获取当前用户选中菜单
    getCurrentUserMenus(row) {
      const that = this;
      this.axios
        .get('/api/user-info/getRoleAndMenu', {
          params: { userInfoId: this.dialogUserInfoId },
        })
        .then((res) => {
          const data = res.data.data;
          console.log('data', data);
          for (let item1 of data) {
            if (item1) {
              // that.treeMenuCheckKeys.push(item1.id);
              if (item1.childList && item1.childList.length > 0) {
                for (let item2 of item1.childList) {
                  that.treeMenuCheckKeys.push(item2.id);
                }
              }
            }
          }
          that.menuAuthDialog = true;
          that.treeCurNodeKeys = that.treeMenuCheckKeys.join();
          console.log('that.treeCurNodeKeys', that.treeCurNodeKeys);
          that.$nextTick(() => {
            that.$refs.menusTree.setCheckedKeys(that.treeMenuCheckKeys);
          });
        });
    },
    addMenusDialog() {
      const curKeysParent = this.$refs.menusTree.getHalfCheckedKeys();
      const curKeysChild = this.$refs.menusTree.getCheckedKeys();
      this.axios.put('/api/user-info/modify/user-menu', { menuIds: [...curKeysParent, ...curKeysChild], userInfoId: this.dialogUserInfoId }).then((res) => {
        if (res.data.code == 200) {
          this.$message('修改成功');
          this.query(); /*查询渲染界面*/
          this.menuAuthDialog = false;
        } else {
          this.$message.info(res.data.msg);
        }
      });
    },
    // 显示门店授权弹窗
    showShopDialog(row) {
      this.dialogUserInfoId = row.userInfoId;
      this.multipleSelection = [];
      this.axios.get('/api/user-info/getUserShop', {
          params: { userInfoId: row.userInfoId },
        })
        .then((res) => {
          const data = res.data.data;
          if (data.length === 0) {
            this.dataShops.forEach((itemShop, index) => {
              this.$refs.shopTableRef.toggleRowSelection(this.dataShops[index], false); //默认选中
            });
          } else {
            for (let item of data) {
              if (item.shopId) {
                this.multipleSelection.push(item.shopId);
                // 绑定默认选中
                this.dataShops.forEach((itemShop, index) => {
                  if (itemShop.id === item.shopId) {
                    this.$refs.shopTableRef.toggleRowSelection(this.dataShops[index], true); //默认选中
                  }
                });
              }
            }
          }
        });
      this.shopAuthDialog = true;
    },
    selectable(row, index) {
      if (row.expenseStatus == 1) {
        return false;
      } else {
        return true;
      }
    },
    handleSelectionChange(val) {
      let selectId = [];
      if (val) {
        val.forEach(function(item, index) {
          if (item) {
            selectId.push(item.id);
          }
        });
      }
      this.multipleSelection = selectId;
    },
    addUserShopDialog() {
      this.axios.put('/api/user-info/modify/user-shop', { shopIds: this.multipleSelection, userInfoId: this.dialogUserInfoId }).then((res) => {
        if (res.data.code == 200) {
          this.$message('修改成功');
          this.query(); /*查询渲染界面*/
          this.shopAuthDialog = false;
        } else {
          this.$message.info(res.data.msg);
        }
      });
    },
  },
  mounted: function() {
    this.active = this.$route.name;
    this.query();
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: calc(100vh - 70px);

  .title {
    height: 50px !important;
    color: white;
    font-size: 16px;
    background: #4c74e0;
    line-height: 50px;
    font-family: Source Han Sans CN;
    font-weight: 400;
  }
  &-content {
    background-color: white;
    height: calc(100vh - 100px);
    overflow: hidden;
  }
  /*分页插件*/
  .el-pagination {
    background-color: #fff;
    padding: 15px;
    text-align: center;
    z-index: 55555;
  }
}
.center-dialog {
  top: 20%;
}
.fs-icon {
  font-size: 24px;
  margin-right: 5px;
}
.el-pagination.is-background /deep/ .el-pager li:not(.disabled).active {
  background-color: #7698fc;
}

/*滚动条样式*/
/deep/ .scrollbar {
  white-space: nowrap;
  .el-scrollbar {
    display: flex;
    justify-content: space-around;
    padding: 0 10px;
  }
  /deep/ .el-scrollbar__wrap {
    overflow: scroll;
    width: 110%;
    height: 100%;
  }
}

.ant-card {
  width: 1230px;
  height: 600px;
  background: #ffffff;
  border-radius: 6px;

  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  transition: all 0.3s;
}
.showAll_dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  ::v-deep .el-dialog {
    margin: 0 auto !important;
    height: 50%;
    overflow: hidden;
    .el-dialog__body {
      position: absolute;
      left: 0;
      top: 40px;
      bottom: 0;
      right: 0;
      padding: 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
      // 下边设置字体，我的需求是黑底白字
      color: #ffffff;
      line-height: 30px;
      padding: 10px 15px;
    }
  }
}
// .form-dialog{
//   margin-top: 30px;
// }
.dialog-large {
  top: 15%;
  ::v-deep .el-dialog {
    margin: 0 auto !important;
    height: 66%;
    overflow: hidden;
    .el-dialog__body {
      // position: absolute;
      // left: 0;
      // top: 40px;
      // bottom: 0;
      // right: 0;
      // padding: 0;
      // z-index: 1;
      height: 60%;
      overflow: hidden;
      overflow-y: auto;
      // 下边设置字体，我的需求是黑底白字
      color: #ffffff;
      line-height: 30px;
      padding: 10px 15px;
    }
  }
}
.menus-tree {
  margin-left: 50px;
}
.footer-btn {
  height: 50px;
  text-align: center;
  padding: 10px 0;
}
</style>
